export default __webpack_public_path__ + "static/media/witmeg-logo.489aae53.svg";